export const storeItemToLocalStorage = (key: string, data: string) => {
    localStorage.setItem(key, data);
};

export const getItemFromLocalStorage = (key: string) => {
    return localStorage.getItem(key);
};

export const removeItemFromLocalStorage = (key: string) => {
    return localStorage.removeItem(key);
};
